module.exports = __webpack_public_path__ + "img/icon-search.5c72709d.svg";